<template>
  <div v-show="isReady && !isHidden && (!isHideOffline || isOnline || isSwayChatPopout)"
    id="swaychat_chat_widget" class="swaychat_chat_widget" :class="{
    'swaychat-chatbox-position-bottom-right': getPosition == 'bottom-right',
    'swaychat-chatbox-position-bottom-left': getPosition == 'bottom-left',
    'swaychat-chatbox-position-top-right': getPosition == 'top-right',
    'swaychat-chatbox-position-top-left': getPosition == 'top-left',
    'swaychat-popout': isSwayChatPopout,
    'swaychat-nobrand': hideBrand,
    'swaychat-bubblehead': getStartUpMode == 'bubblehead' && isMinimize && !isSwayChatPopout,
    'swaychat-pre-chat': getViewState == 1
  }">
        <popout></popout>
        <container-component>
            <header-component></header-component>
            <div class="swaychat-chatbox">
                <prechat-component v-if="getViewState == 1 && isPreChat"></prechat-component>
                <div v-if="(getViewState > 1 && getViewState < 4) || (getViewState == 1 && !isPreChat)">
                    <conversation-component></conversation-component>
                    <file-upload></file-upload>
                    <message-alert></message-alert>
                    <message-box-component></message-box-component>
                </div>
                <end-chat-component v-if="getViewState == 4"></end-chat-component>
            </div>
        </container-component>
        <minimize-component v-if="getStartUpMode == 'minimize' && !isSwayChatPopout"></minimize-component>
        <bubble-head v-if="getStartUpMode == 'bubblehead' && !isSwayChatPopout"></bubble-head>
        <notifications></notifications>
        <light-box></light-box>
    </div>
</template>

<script>
  import '../styles/default.scss'

  import store from '../vuex/store'
  import frameStorage from '../utils/storage/frame'
  import firebaseApp from '../utils/firebase'
  import axios from 'axios/dist/axios'
  import TimeMe from 'timeme.js'
  import Raven from 'raven-js'

  import {
    mapGetters
  } from 'vuex'

  import {
    API, fetchQueue
  } from '../utils/api'
  import {
    w
  } from '../utils/helpers'

  import Popout from './PopOutComponent.vue'
  import ContainerComponent from './ContainerComponent.vue'
  import HeaderComponent from './HeaderComponent.vue'
  import MinimizeComponent from './MinimizeComponent.vue'
  import PrechatComponent from './PrechatComponent.vue'
  import ConversationComponent from './ConversationComponent.vue'
  import FileUpload from './FileUpload.vue'
  import MessageAlert from './MessageAlert.vue'
  import MessageBoxComponent from './MessageBoxComponent.vue'
  import EndChatComponent from './EndChatComponent.vue'
  import BubbleHead from './BubbleHead.vue'
  import Notifications from './Notifications.vue'
  import LightBox from './LightBox.vue'

  export default {
    components: {
      Popout,
      ContainerComponent,
      HeaderComponent,
      MinimizeComponent,
      ConversationComponent,
      FileUpload,
      MessageAlert,
      MessageBoxComponent,
      PrechatComponent,
      EndChatComponent,
      BubbleHead,
      Notifications,
      LightBox
    },
    beforeCreate() {

      //Initialize Tools

      firebaseApp.init(w.orgId)
      TimeMe.initialize({
        idleTimeoutInSeconds: 30
      })

      frameStorage.init(this.$store)

    },
    created() {
      this.$store.dispatch('setOrgWidget', w.dataset)
      this.$store.dispatch('bindWidget', {
        ref: firebaseApp.ref,
        widgetId: w.widgetId
      })

      if (this.isFocused)
        this.intervalTimeUpdate()

      TimeMe.callWhenUserReturns(()=>{
        this.intervalTimeUpdate()
        this.$store.dispatch('updatePageFocus', true)
        this.$store.commit('setFocus', true)
      })

      TimeMe.callWhenUserLeaves(()=>{
        clearTimeout(this.timer)
        this.$store.dispatch('updateTimeOn')
        this.$store.dispatch('updatePageFocus', false)
        this.$store.commit('setFocus', false)
      })

      //Prefill API preboot
      API.$on('sessionConnected', ()=>{
        let f = fetchQueue('setUser')
        if (f)
          this.$store.dispatch('saveMeta',f[0])
      })

      //Manual Update
      API.$on('setUser', (user)=>{
        this.$store.dispatch('saveMeta', user)
      })

      //Get User API
      API.$on('getUser', (callback)=>{
        if (typeof callback === 'function')
          callback(this.getUser)
      })

      //new bind API
      API.$on('toggleMinimize', this.toggleMinimize)
      API.$on('setHidden', this.setHidden)

      // if setHidden was called prior to boot
      let h = fetchQueue('setHidden')
      if (h) this.$store.dispatch('setHidden',h[0])

      //process postMessage API requests when ready
      API.$on('messagesBound', this.processBootPostMessage)
      API.$on('postMessage', (message, isPrivate)=>{
        this.$store.dispatch('jsPostMessage',{
          message,
          'private': isPrivate ? true : false
        })
      })


      API.$on('setLang', (label,value)=>{
        this.$store.dispatch('updateTempLang', {label,value})
      })

      API.$on('setHeader', (when,label,value)=>{
        this.$store.dispatch('updateHeader',{when,label, value})
      })

      API.$on('widgetConnected',()=>{

        let sL = fetchQueue('setLang')
        if (sL) this.$store.dispatch('updateTempLang',{label:sL[0],value:sL[1]})

        let sH = fetchQueue('setHeader')
        if (sH) this.$store.dispatch('updateHeader',{when:sH[0],label:[sH[1]],value:sH[2]})

      })

      //listen for popstate
      window.addEventListener('popstate',()=>{
        //console.log('popstate',location.href)
        this.$store.dispatch('postPageEvent')
        this.$store.dispatch('postPageHistory')
      })

      //listen for pushstate
      window.addEventListener('pushState',()=>{
        //console.log('pushState',location.href)
        this.$store.dispatch('postPageEvent')
        this.$store.dispatch('postPageHistory')
      })

      //support old toggle minimize API
      let toggleButtons = document.getElementsByClassName('SwayChat-Toggle')
      if (toggleButtons && toggleButtons.length) {
        for (let i = 0, len = toggleButtons.length; i < len; i++) {
          toggleButtons[i].addEventListener('click', this.toggleMinimize)
          toggleButtons[i].classList.remove('swaychat-toggle-hide')
        }
      }

      //support old popout API
      let popoutButtons = document.getElementsByClassName('SwayChat-Popout')
      if (popoutButtons && popoutButtons.length) {
        for (let i = 0, len = popoutButtons.length; i < len; i++) {
          popoutButtons[i].addEventListener('click', (e)=>{
            e.preventDefault()
            API.$emit('popOutOpen')
          })
        }
      }

    },
    computed: {
      ...mapGetters([
        'isReady',
        'isHidden',
        'isFocused',
        'isSynced',
        'isConnected',
        'isHideOffline',
        'isOnline',
        'isSwayChatPopout',
        'isMinimize',
        'getStartUpMode',
        'getPosition',
        'getViewState',
        'bindSID',
        'bindUID',
        'isPreChat',
        'hideBrand',
        'notifyInstall',
        'getReactions',
        'getUser'
      ])
    },
    data() {
      return {
        sessionRef: null,
        messageRef: null,
        historyRef: null,
        visitorRef: null,
        timer: null,
        numTries: 0,
      }
    },
    watch: {
      isConnected() {
        this.$store.dispatch('bindConnected', firebaseApp.ref)
        this.$store.dispatch('checkInstallation')
      },
      isSynced() {
        this.signIn()
      },
      bindUID(newUID) {
        if (newUID) {

          this.visitorRef = firebaseApp.ref.child('visitors').child(newUID)
          //moved from session / evaluate usefulness

          this.visitorRef.child('visitor_status').onDisconnect().set('away')
          this.visitorRef.child('visitor_status').on('value', (snap)=>{
            if (snap.val() != 'online')
              snap.ref.set('online')
          })

          this.$store.dispatch('bindVisitor', this.visitorRef)

        }
      },
      bindSID(newSID) {
        if (newSID) {

          //bind session
          //keep online state unless switched
          Raven.setUserContext({
            orgId: w.orgId,
            widgetId: w.widgetId,
            sessionId: newSID
          })

          this.$store.dispatch('disconnectPageEvent')
          this.$store.dispatch('disconnectHistory')

          this.sessionRef = firebaseApp.ref.child('sessions').child(newSID)
          this.$store.dispatch('bindSession', this.sessionRef)

          //bind messages
          this.messageRef = firebaseApp.ref.child('messages').child(newSID)
          this.$store.dispatch('bindMessages', this.messageRef)

          //add history here
          this.historyRef = firebaseApp.ref.child('history').child(newSID)
          this.$store.dispatch('bindHistory', this.historyRef)

          this.$store.dispatch('updateLobby')

        }
      },
      getReactions(reactions) {
        if (reactions)
          this.$store.dispatch('triggerReactions', reactions)
      }
    },
    methods: {
      signIn(token) {
        Raven.captureBreadcrumb({
          message: 'Attempt signin',
          category: 'requests',
          data: {
             token
          }
        });

        firebaseApp.signInUser(token).then((a) => {
          API.$emit('connected')
          this.$store.commit('setConnectedState', true)
        })
          .then(()=>{

            //console.log(this.bindUID)
            if (!this.bindUID) {
              if (this.numTries < 5) {
                this.numTries++
                setTimeout(() => {
                  this.requestAPI('token')
                }, this.numTries * 1000)
              } else {
                Raven.captureMessage('Failed to signin', {
                  level: 'error'
                });
              }
            }

          })
          .catch((e) => {

            if ((e.code == 'auth/invalid-custom-token' ||
              e.code == 'no-token') &&
              this.numTries < 5
            ) {
              this.numTries++
              setTimeout(() => {
                this.requestAPI('token')
              }, this.numTries * 500)
            } else if (this.numTries >= 5) {
              Raven.captureMessage('Failed to signin', {
                level: 'error'
              });
            }

          })

      },
      requestAPI(action) {
        const state = this.$store.state
        const data = {
          organization_id: state.orgId,
          widget_id: state.widgetId,
        }

        if (action) {
          data.sid = state.visitor ? state.visitor.session_id : null
          data.uid = state.uid
        }

        let uri = 'visitor' + (data.uid && data.sid ? '/' + action : '')

        Raven.captureBreadcrumb({
          message: 'Requesting',
          category: 'requests',
          data: {
             uri,
             ...data
          }
        });

        return axios({
          method: 'post',
          url: '@@API/' + uri,
          timeout: 30000,
          data
        })
          .then(response => {

            const { token, session_id, uid } = response.data.data

            uid && this.$store.commit('setUID', uid)
            token && this.signIn(token)

          })
          .catch(e=>{
            Raven.captureBreadcrumb({
              message: 'Error on API request',
              category: 'requests',
              data: {
                status: e.response && e.response.status || '',
                statusText: e.response && e.response.statusText || '',
                responseData: e.response && e.response.data || ''
              }
            });
            if (this.numTries >= 5)
              Raven.captureException(e)
          })

      },
      // Browser API
      toggleMinimize(e) {
        if (e)
          e.preventDefault()
        this.$store.dispatch('toggleMinimize', true)
      },
      setHidden(value, e) {
        if (e)
          e.preventDefault()
        this.$store.dispatch('setHidden', !!value)
      },
      intervalTimeUpdate() {

        this.$store.dispatch('updateTimeOn')

        clearTimeout(this.timer)
        this.timer = setTimeout(this.intervalTimeUpdate, 15000)

      },
      processBootPostMessage() {

        let f = fetchQueue('postMessage')
        if (f) this.$store.dispatch('jsPostMessage',{
          'message': f[0],
          'private': f[1] ? true : false
        })


      }
    },
    store
  }
</script>
